import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Layout } from '../../components/layout/Layout';
import { PageHeader } from '../../components/layout/PageHeader';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { Alert } from '../../components/ui/Alert';
import { linkChild } from '../../modules/platform/api/onboarding';
import { showErrorToast, showSuccessToast } from '../../utils/errorHandler';
import { ROUTES } from '../../utils/constants';
import { useNavigate } from 'react-router-dom';

interface LinkChildFormData {
  link_code: string;
}

export const LinkChild: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<LinkChildFormData>();

  const onSubmit = async (data: LinkChildFormData) => {
    setIsLoading(true);
    try {
      const response = await linkChild({ link_code: data.link_code });
      showSuccessToast(`Successfully linked to ${response.student.name}!`);
      navigate(ROUTES.PARENT_CHILDREN);
    } catch (error) {
      showErrorToast(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Layout>
      <PageHeader
        title="Link Child"
        subtitle="Link your account to your child's student record"
      />

      <Card className="max-w-md">
        <CardHeader>
          <CardTitle>Enter Link Code</CardTitle>
        </CardHeader>
        <CardContent>
          <Alert variant="info" className="mb-4">
            Ask your school administrator for a link code to connect your account to your child's record.
          </Alert>

          <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
            <Input
              label="Link Code"
              {...register('link_code', {
                required: 'Link code is required',
                minLength: { value: 6, message: 'Link code must be at least 6 characters' },
              })}
              error={errors.link_code?.message}
              placeholder="ABC123XY"
              helperText="Enter the 8-character code provided by your school"
            />

            <Button type="submit" isLoading={isLoading} className="w-full">
              Link Child
            </Button>
          </form>
        </CardContent>
      </Card>
    </Layout>
  );
};

